/* KvD Bike-Vergleich v6 – Logik. Daten kommen aus <script type="application/json" id="kvd-cmp-data">. */
(function(){
  'use strict';
  const ROOT=document.getElementById('kvd-cmp');
  const DATA_EL=document.getElementById('kvd-cmp-data');
  if(!ROOT||!DATA_EL)return;
  let DATA;
  try{DATA=JSON.parse(DATA_EL.textContent);}catch(e){ROOT.remove();return;}
  const CUR=DATA.cur;
  const CATALOG=(DATA.catalog||[]).sort((a,b)=>a.price-b.price);
  if(!CUR||!CATALOG.length){ROOT.remove();return;}

  const BODY=document.getElementById('kvd-cmp-body');
  const HD=document.getElementById('kvd-cmp-hd');
  const TLBL=document.getElementById('kvd-cmp-tlbl');

  const SPECS=[{key:'rahmen',label:'Rahmen'},{key:'gabel',label:'Gabel'},{key:'schaltung',label:'Schaltung'},{key:'bremsen',label:'Bremsen'},{key:'reifen',label:'Reifen'}];

  // Startauswahl: preislich naechste Bikes
  const NEAREST=[...CATALOG].sort((a,b)=>Math.abs(a.price-CUR.price)-Math.abs(b.price-CUR.price));
  let slots=[NEAREST[0]||null,NEAREST[1]||null];

  HD.addEventListener('click',()=>{
    const col=ROOT.classList.toggle('kvd-cmp--collapsed');
    HD.setAttribute('aria-expanded',!col);
    TLBL.textContent=col?'Ausklappen':'Einklappen';
  });
  HD.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();HD.click();}});

  const fmt=n=>new Intl.NumberFormat('de-DE',{style:'currency',currency:'EUR',minimumFractionDigits:0,maximumFractionDigits:0}).format(n);
  const esc=s=>String(s==null?'':s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const DASH='<span class="kvd-cmp__spec-cell--dim">&ndash;</span>';

  function colHTML(prod,isCur,slotIdx){
    const p=isCur?CUR:prod;
    const isEmpty=!p;
    const nameHTML=!isCur&&p?`<a href="${esc(p.url)}">${esc(p.title)}</a>`:esc(p?.title);
    return `<div class="kvd-cmp__col${isCur?' kvd-cmp__col--current':''}"><div class="kvd-cmp__col-top">
      <div class="kvd-cmp__row-badge">${isCur?'<span class="kvd-cmp__current-tag">Dieses Bike</span>':'<span class="kvd-cmp__current-tag" style="visibility:hidden">x</span>'}</div>
      <div class="kvd-cmp__row-img"><div class="kvd-cmp__img-wrap"${!isCur?` data-slot="${slotIdx}"`:''}>
        ${p&&p.img?`<img src="${esc(p.img)}" alt="${esc(p.title)}" loading="lazy">`:`<div class="kvd-cmp__img-placeholder"><span>${isEmpty?'Bike w&auml;hlen':''}</span></div>`}
        ${!isCur?'<div class="kvd-cmp__swap-hint">Bike austauschen</div>':''}
        ${!isCur?`<div class="kvd-cmp__picker" id="kvd-pk-${slotIdx}"></div>`:''}
      </div></div>
      <div class="kvd-cmp__row-vendor">${!isEmpty?`<p class="kvd-cmp__vendor">${esc(p.vendor)}</p>`:''}</div>
      <div class="kvd-cmp__row-name">${!isEmpty?`<p class="kvd-cmp__name">${nameHTML}</p><p class="kvd-cmp__price">${p.price!=null?fmt(p.price):''}</p>`:''}</div>
      <div class="kvd-cmp__row-btn">${!isEmpty&&p.variantId?`<button class="kvd-cmp__atc" data-vid="${p.variantId}"${!p.available?' disabled':''} type="button">${p.available?'In den Warenkorb':'Ausverkauft'}</button>`:''}</div>
    </div></div>`;
  }

  const norm=s=>(s||'').toLowerCase().replace(/\s+/g,' ').trim();
  function cellClass(val,allVals,isCurrent){
    const base=isCurrent?'kvd-cmp__spec-cell kvd-cmp__spec-cell--current':'kvd-cmp__spec-cell';
    if(!val)return base+' kvd-cmp__spec-cell--dim';
    const filled=allVals.filter(Boolean);
    if(filled.length<2||filled.every(v=>norm(v)===norm(filled[0])))return base;
    return base+' kvd-cmp__spec-cell--diff';
  }

  const GROUPSET_SCORES=[
    [/dura.?ace|r9[12]/i,10],[/ultegra.?di2|r8[12][05]0.*di2/i,9],[/ultegra|r81[05]0/i,8],[/105.*di2|r71[05]0.*di2/i,7],[/105|r71[05]0/i,6],[/tiagra|r45/i,4],[/sora|r30/i,3],[/claris|r20/i,2],
    [/grx.*di2.*rx825|rx825/i,9],[/grx.*rx820|rx820/i,7],[/grx.*rx822|rx822/i,7],[/grx.*rx610|rx610/i,5],[/grx.*rx400|rx400/i,4],[/grx.*rx410|rx410/i,4],[/cues.*u8/i,6],[/cues.*u6/i,4],[/cues/i,3],
    [/xtr|m9[12]/i,10],[/xt|m81[05]0/i,8],[/slx|m72/i,6],[/deore.*m6[12]/i,5],[/deore/i,4],[/alivio/i,3],[/altus/i,2],
    [/red.*axs/i,10],[/force.*axs.*power.*meter|force.*axs.*e1.*power/i,9],[/force.*axs|force.*e1/i,8],[/rival.*axs.*xplr.*13|rival.*xplr.*axs/i,7],[/rival.*axs|rival.*etap/i,6],[/rival(?!.*axs)/i,5],[/apex/i,4],
    [/xx1.*eagle|xx.*eagle/i,10],[/x01.*eagle/i,9],[/gx.*eagle/i,7],[/nx.*eagle/i,5],[/sx.*eagle/i,4],[/x5|x7/i,3],
    [/super.*record/i,10],[/record/i,9],[/chorus/i,7],[/potenza|centaur/i,5],[/microshift.*acolyte/i,3],[/microshift/i,2]
  ];
  const FRAME_SCORES=[[/carbon.*omx|omx|textreme|toray.*pitch|nippon.*graphite/i,10],[/full.*carbon|carbon.*monocoque|carbon.*icr|high.*modulus/i,9],[/carbon/i,7],[/aluminium.*hydroform|aluminium.*tapered|6061.*t6/i,5],[/aluminium|alloy|aluminum/i,4],[/steel|chromoly/i,3]];
  const BRAKE_SCORES=[[/magura.*mt|mt.*trail|mt.*sport/i,8],[/hydr.*disc|hydraulic.*disc|disc.*hydraulic|hydraulische.*scheibe|scheibenbremse/i,8],[/disc/i,5],[/rim.*brake|v.brake|caliper/i,3],[/mini.*v|v-brake/i,2]];

  function scoreFor(text,table){if(!text)return 0;const t=text.toLowerCase();for(const [re,s] of table){if(re.test(t))return s;}return 0;}
  function calcSpecLevel(m){
    const g=scoreFor(m.schaltung,GROUPSET_SCORES),f=scoreFor(m.rahmen,FRAME_SCORES),b=scoreFor(m.bremsen,BRAKE_SCORES);
    if(!g&&!f&&!b)return null;
    return Math.round((g*0.5+f*0.35+b*0.15)*10)/10;
  }
  function specLevelBar(score,max){
    const pct=Math.round(score/max*100);
    return `<div class="kvd-sl__bar-wrap"><div class="kvd-sl__bar-track"><div class="kvd-sl__bar-fill" style="width:${pct}%"></div></div><span class="kvd-sl__score">${score.toFixed(1)}</span></div>`;
  }
  function specLevelSection(){
    const s=[calcSpecLevel(CUR.meta),slots[0]?calcSpecLevel(slots[0].meta):null,slots[1]?calcSpecLevel(slots[1].meta):null];
    const scored=s.filter(x=>x!==null);
    if(scored.length<2)return '';
    const max=Math.max(...scored);
    const c=(v,cur)=>`<div class="kvd-cmp__spec-cell${cur?' kvd-cmp__spec-cell--current':''} kvd-sl__cell">${v!==null&&v>0?specLevelBar(v,max):DASH}</div>`;
    return `<div class="kvd-cmp__spec-group kvd-sl"><div class="kvd-cmp__spec-lbl-row"><span>Spec Level</span></div><div class="kvd-cmp__spec-vals">${c(s[0],true)}${c(s[1],false)}${c(s[2],false)}</div></div>`;
  }

  function specsHTML(){
    const prices=[CUR.price,...slots.filter(Boolean).map(p=>p.price)];
    const minP=Math.min(...prices),maxP=Math.max(...prices);
    let h=specLevelSection();
    SPECS.forEach(spec=>{
      const v=[CUR.meta[spec.key]||'',slots[0]?.meta?.[spec.key]||'',slots[1]?.meta?.[spec.key]||''];
      if(!v[0]&&!v[1]&&!v[2])return;
      const cell=(val,i)=>`<div class="${cellClass(val,v,i===0)}">${val?esc(val):DASH}</div>`;
      h+=`<div class="kvd-cmp__spec-group"><div class="kvd-cmp__spec-lbl-row"><span>${spec.label}</span></div><div class="kvd-cmp__spec-vals">${v.map(cell).join('')}</div></div>`;
    });
    const priceCell=(p,cur)=>{
      const base=cur?'kvd-cmp__spec-cell kvd-cmp__spec-cell--current':'kvd-cmp__spec-cell';
      if(p==null)return `<div class="${base}">${DASH}</div>`;
      const multi=prices.length>1&&maxP!==minP;
      const isBest=multi&&p===minP, isMost=multi&&p===maxP;
      const cls=isBest?base+' kvd-cmp__spec-cell--price-best':isMost?base+' kvd-cmp__spec-cell--price-high':base;
      return `<div class="${cls}">${fmt(p)}${isBest?' <span class="kvd-cmp__price-badge kvd-cmp__price-badge--best">G&uuml;nstigster</span>':''}</div>`;
    };
    h+=`<div class="kvd-cmp__spec-group"><div class="kvd-cmp__spec-lbl-row"><span>Preis</span></div><div class="kvd-cmp__spec-vals">${priceCell(CUR.price,true)}${priceCell(slots[0]?.price??null,false)}${priceCell(slots[1]?.price??null,false)}</div></div>`;
    return h;
  }

  function alignRows(){
    ['.kvd-cmp__row-badge','.kvd-cmp__row-img','.kvd-cmp__row-vendor','.kvd-cmp__row-name','.kvd-cmp__row-btn'].forEach(sel=>{
      const cells=BODY.querySelectorAll(sel);
      if(!cells.length)return;
      cells.forEach(c=>c.style.minHeight='');
      const maxH=Math.max(...Array.from(cells).map(c=>c.offsetHeight));
      cells.forEach(c=>c.style.minHeight=maxH+'px');
    });
  }

  const closePickers=()=>BODY.querySelectorAll('.kvd-cmp__picker').forEach(p=>p.classList.remove('is-open'));
  function openPicker(slotIdx){
    closePickers();
    const el=document.getElementById(`kvd-pk-${slotIdx}`);
    if(!el)return;
    const otherId=slots[slotIdx===0?1:0]?.id;
    const list=CATALOG.filter(p=>p.id!==otherId);
    el.innerHTML=!list.length?'<div class="kvd-cmp__picker-empty">Keine weiteren Bikes verf&uuml;gbar</div>':
      `<div class="kvd-cmp__picker-hd"><span>Bike w&auml;hlen</span><button class="kvd-cmp__picker-close" type="button" aria-label="Schlie&szlig;en"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button></div>`+
      list.map(p=>`<div class="kvd-cmp__picker-item" data-id="${p.id}" data-slot="${slotIdx}"><img class="kvd-cmp__picker-img" src="${esc(p.img)}" alt="" loading="lazy"><div><div class="kvd-cmp__picker-name">${esc(p.title)}</div><div class="kvd-cmp__picker-price">${fmt(p.price)}</div></div></div>`).join('');
    el.classList.add('is-open');
  }

  function render(){
    BODY.innerHTML=`<div class="kvd-cmp__scroll"><div class="kvd-cmp__cols">${colHTML(null,true,-1)}${colHTML(slots[0],false,0)}${colHTML(slots[1],false,1)}</div><div class="kvd-cmp__specs">${specsHTML()}</div></div>`;
    alignRows();
  }

  // Einmalig gebunden (alte Version band bei jedem Render neue Listener -> Mehrfach-Ausloesung)
  BODY.addEventListener('click',async e=>{
    const item=e.target.closest('.kvd-cmp__picker-item');
    if(item){
      const prod=CATALOG.find(p=>String(p.id)===item.dataset.id);
      if(prod){slots[parseInt(item.dataset.slot,10)]=prod;render();}
      return;
    }
    if(e.target.closest('.kvd-cmp__picker-close')){closePickers();return;}
    const wrap=e.target.closest('.kvd-cmp__img-wrap[data-slot]');
    if(wrap&&!e.target.closest('.kvd-cmp__picker')){openPicker(parseInt(wrap.dataset.slot,10));return;}
    const btn=e.target.closest('.kvd-cmp__atc');
    if(btn&&!btn.disabled){
      const orig=btn.textContent;
      btn.disabled=true;btn.textContent='…';
      try{
        const res=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:parseInt(btn.dataset.vid,10),quantity:1})});
        if(!res.ok)throw new Error();
        btn.textContent='✓ Hinzugefügt';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('theme:cart:add'));
        setTimeout(()=>{btn.textContent=orig;btn.disabled=false;},2200);
      }catch(err){
        btn.textContent='Fehler';
        setTimeout(()=>{btn.textContent=orig;btn.disabled=false;},2000);
      }
    }
  });
  document.addEventListener('click',e=>{if(!e.target.closest('.kvd-cmp__img-wrap[data-slot]'))closePickers();},{passive:true});
  window.addEventListener('resize',alignRows,{passive:true});

  render();
})();